import { render, staticRenderFns } from "./MainChartExample.vue?vue&type=template&id=2ac065a0&"
import script from "./MainChartExample.vue?vue&type=script&lang=js&"
export * from "./MainChartExample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports